import { render, staticRenderFns } from "./propriedadesParticula.vue?vue&type=template&id=78be32b4&"
import script from "./propriedadesParticula.vue?vue&type=script&lang=js&"
export * from "./propriedadesParticula.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports